import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import authReducer from '../api/auth/authSlice';
import orgReducer from '../api/organizations/orgSlice';
import subscriptionReducer from '../api/subscription/subscriptionSlice';
import userReducer from '../api/user/userSlice';
import snackbarReducer from '../api/snackbarSlice';
import participantsReducer from '../api/participants/participantsSlice';
import pdfDataExtractionReducer from '../api/pdfDataExtraction/pdfDataExtractionSlice';
import rootSaga from '../api/rootSaga';
import codeListsReducer from '../api/codelist/codeListsSlice';
import loaderReducer from '../api/loader/loaderSlice';
import languageReducer from '../api/ui/languageSlice';

const sagaMiddleware = createSagaMiddleware();

const appReducer = combineReducers({
  auth: authReducer,
  org: orgReducer,
  subscription: subscriptionReducer,
  user: userReducer,
  snackbar: snackbarReducer,
  participants: participantsReducer,
  extractions: pdfDataExtractionReducer,
  codeLists: codeListsReducer,
  loader: loaderReducer,
  language: languageReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = {
      ...state,
      org: undefined,
      subscription: undefined,
      participants: undefined,
      extractions: undefined,
      user: undefined,
    };
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
